
import React, { Component } from 'react';
import './delete-teacher.scss'
import { Modal, ModalBody } from "reactstrap";
import { ImageConstants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import SchoolApi from '../../../apis/school'
import PillButton from '../../common/pill-button-select/pill-button-select'
import Dropdown from '../../common/dropdown-v2/dropdown';
import AddNewTeacher from '../../teachers/add-new-contact/add-new-contact';
import SessionCache from '../../routes/session-cache';

class DeleteTeacher extends Component {

    state = {
        classHash: {}
    }
    user = {}
    componentDidMount() {
        this.user = SessionCache.getUser()
        this.prepareClassList()
        this.getStaffs()
    }

    getStaffs(payload = {}) {
        payload.types = `in/MATH_TEACHER`
        SchoolApi.getStaffs(payload)
            .then(staffs => {
                let mathTeachers = [], mathTeachersHash = {};
                for (let i = 0; i < staffs?.response?.length; i++) {
                    let staff = staffs?.response[i]

                    for (let j = 0; j < staff?.types?.length; j++) {
                        if (!mathTeachersHash[staff._id]) {
                            mathTeachersHash[staff._id] = true
                            if (staff._id == this.props.teacher?._id) continue
                            mathTeachers.push({
                                title: staff.firstName,
                                value: staff._id,
                            })
                        }
                    }

                }
                this.setState({ mathTeacherDropdown: mathTeachers, reloadDropdown: true }, () => {
                    this.setState({ reloadDropdown: false })
                })
            }).catch(err => {
            })
    }

    prepareClassList() {
        let classes = this.props.teacher?.classes || []
        classes.sort((a, b) => a.class > b.class ? 1 : -1)
        let classHash = {}
        for (let i = 0; i < classes.length; i++) {
            if (classHash[classes[i].class]) {
                classHash[classes[i].class].push(classes[i])
            } else {
                classHash[classes[i].class] = [classes[i]]

            }
        }
        let classNames = []
        for (let key in classHash) {
            classNames.push({
                value: key,
                title: key
            })
        }
        let selectedClass = ""
        if (classNames.length == 1) {
            selectedClass = classNames[0].value
        }
        this.setState({ classHash, classes: classNames, selectedClass })
    }

    onClickOkay = () => {
        this.props.onOk && this.props.onOk()
    }

    onClickContinue = () => {
        this.setState({ isContinue: true })
    }

    onCLickCancel = () => {
        this.props.close && this.props.close()
    }

    getHisOrHer(teacher) {
        if (teacher?.gender == "Mrs." || teacher?.gender == "Miss.") return "Her"
        return "His"
    }

    renderSectionInfo() {
        let classHash = this.state.classHash
        let arr = []
        for (let key in classHash) {
            let item = classHash[key]
            arr.push(<div>{key} : {this.getSectionName(item)}</div>)
        }
        return arr
    }

    getSectionName(data) {
        let names = []
        for (let i = 0; i < data.length; i++) {
            names.push(data[i].section)
        }
        return `Sections ${names.join(", ")}`
    }

    onSelectClass = (option) => {
        this.setState({ selectedClass: option })
    }

    addNewTeacher(index) {
        this.setState({ showAddNewTeacher: true, addTeacherIndex: index })
    }

    hideNewTeacher = (selectedTeacherId) => {
        this.setState({ showAddNewTeacher: false })
        if (selectedTeacherId) {
            let sections = this.state.classHash[this.state.selectedClass]

            sections[this.state.addTeacherIndex].teacherId = selectedTeacherId
            let classHash = this.state.classHash
            classHash[this.state.selectedClass] = sections

            this.setState({ classHash, reloadDropdown: true }, () => {
                this.setState({ reloadDropdown: false })
                this.onTimeValidation()
            })
        }
        this.getStaffs()
    }

    onSelectMathTeacher(option, index) {
        let sections = this.state.classHash[this.state.selectedClass]

        sections[index].teacherId = option?.value || null
        let classHash = this.state.classHash
        classHash[this.state.selectedClass] = sections
        this.setState({ classHash }, () => {
            this.onTimeValidation()
        })
    }

    onClickDelete = () => {
        let { payload, validation } = this.preparePayload()
        if (!validation) {
            this.setState({ isSubmit: true })
            return
        }
        let obj = {
            _id: this.props.teacher?._id,
            sections: payload
        }

        SchoolApi.deleteStaff(obj).then(response => {

            this.props.onOk && this.props.onOk()

        }).catch(err => {
        })

    }


    preparePayload() {
        let result = [], validation = true
        let classHash = this.state.classHash
        for (let key in classHash) {
            let classDetail = classHash[key]
            for (let i = 0; i < classDetail.length; i++) {
                let info = classDetail[i]
                let payload = {
                    id: info.sectionId,
                    teacherId: info.teacherId
                }
                if (!info.teacherId) validation = false
                result.push(payload)
            }
        }
        return { payload: result, validation }
    }

    onTimeValidation() {
        let { validation } = this.preparePayload()
        this.setState({ validation })
    }

    renderSectionAssign() {
        let sections = this.state.classHash[this.state.selectedClass]
        return (
            <>{
                sections?.map((item, index) => (
                    <div className="row pt-2">
                        <div className="col-3 my-auto">
                            <span>Section {item?.section} </span>
                        </div>
                        <div className="col my-auto">
                            <div className="row">
                                <div className="col">
                                    {
                                        !this.state.reloadDropdown ?
                                            <Dropdown
                                                key={item.sectionId}
                                                placeholder='Select'
                                                options={this.state?.mathTeacherDropdown}
                                                onSelect={(option) => this.onSelectMathTeacher(option, index)}
                                                text={"title"}
                                                style={{ background: "#F6F7F5" }}
                                                value={item.teacherId || ""}
                                                invalid={this.state.isSubmit && !item.teacherId}
                                            /> : ""
                                    }
                                </div>

                                <div className="col-1 my-auto text-left">
                                    <img className="custom-add-icon cursor-pointer" onClick={() => this.addNewTeacher(index)} src={getImageSource(ImageConstants.ADD)} />
                                </div>
                            </div>
                        </div>
                    </div>
                ))
            }
            </>
        )
    }

    renderAddNewContactModal() {
        return (
            <Modal className="cw-custom-modal" isOpen={true} toggle={this.hideNewTeacher} size={"lg"}>
                <ModalBody >

                    <div className="row">
                        <div className="col text-right">
                            <img className="close-icon cursor-pointer" onClick={this.hideNewTeacher} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>
                    <div className="header-text text-center">
                        <span>{"ADD NEW TEACHER"}</span>
                    </div>
                    <div className="px-4">
                        <AddNewTeacher show={this.state.showAddNewTeacher} onClose={this.hideNewTeacher} size={'lg'} />
                    </div>
                </ModalBody>
            </Modal>)
    }

    render() {
        return (
            <Modal className="cw-custom-modal cw-teacher-delete-modal" isOpen={true} toggle={this.props.close} size={this.props.size || 'lg'}>

                <ModalBody >
                    <div className="delete-teacher">
                        <div className="row">
                            <div className="col">
                                <img className="close-icon cursor-pointer" onClick={this.props.close} src={getImageSource(ImageConstants.CROSS)} />
                            </div>
                        </div>

                        <div>
                            {
                                !this.state.isContinue ?
                                    <div>
                                        <div className="text-center">
                                            <div className="title">Before deleting {this.props.teacher?.firstName}, Assign all {this.getHisOrHer(this.props.teacher)} sections to another teacher </div>
                                        </div>

                                        <div className="py-2 section-title">
                                            {this.renderSectionInfo()}
                                        </div>

                                        <div className="text-center pt-5 pb-4">
                                            <button className="cw-button-primary light mr-2" onClick={this.onCLickCancel}>Cancel</button>
                                            <button className="cw-button-primary" onClick={this.onClickContinue}>Continue </button>
                                        </div>
                                    </div>
                                    :
                                    <div>

                                        <div className="text-center">
                                            <div className="title">Assign new Teacher to {this.props.teacher?.firstName}'s Sections</div>
                                        </div>

                                        <div className='text-center pt-4'>
                                            <PillButton key={'classes'} value={this.state.selectedClass} options={this.state.classes} onSelect={this.onSelectClass} size={'md'} style={{ fontSize: 17, fontWeight: 'bold' }} />
                                        </div>

                                        <div className="py-4 px-5">
                                            {
                                                this.state.selectedClass ? this.renderSectionAssign() : ""
                                            }
                                        </div>
                                        {
                                            this.state.selectedClass ?
                                                <div className="text-center pb-4">
                                                    <button className={`cw-button-primary ${this.state.validation ? "" : "disable-button"}`} onClick={this.onClickDelete}>CONTINUE & DELETE TEACHER</button>
                                                </div>
                                                : ""
                                        }
                                    </div>
                            }
                        </div>
                        {
                            this.state.showAddNewTeacher ? this.renderAddNewContactModal() : ""
                        }
                    </div>
                </ModalBody>

            </Modal >
        );
    }
}

export default DeleteTeacher;